import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import Typography from '../atoms/Typography.mjs';
import modules_979bfa57 from './Divider.module.css.mjs';

const Divider = ()=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    return /*#__PURE__*/ React__default.createElement("div", {
        role: "separator",
        className: modules_979bfa57.container
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: modules_979bfa57.bar
    }), /*#__PURE__*/ React__default.createElement(Typography, {
        variant: "helper"
    }, $__i18n._({
        id: "methodDivider.text"
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: modules_979bfa57.bar
    }));
};

export { Divider as default };
//# sourceMappingURL=Divider.mjs.map
